const SLUG_HOME = "/home";
export const PATH_HOME = `${SLUG_HOME}`;

const SLUG_TAGS = "/tags";
export const PATH_TAGS = `${SLUG_TAGS}`;

const SLUG_CODE_SETTINGS = "/code-settings";
export const PATH_CODE_SETTING = `${SLUG_CODE_SETTINGS}`;

const SLUG_SUBPAGE = "/:subpage";
export const PATH_CODE_SETTING_SUBPAGE = `${SLUG_CODE_SETTINGS}${SLUG_SUBPAGE}`;

const SLUG_ADD = "/add";
const SLUG_EDIT = "/edit/";
const SLUG_EDIT_ID = "/edit/:id";

const SLUG_APPLICANTS = "/applicants";
export const PATH_APPLICANTS = `${SLUG_APPLICANTS}`;
export const PATH_APPLICANTS_ADD = `${SLUG_APPLICANTS}${SLUG_ADD}`;
export const PATH_APPLICANTS_EDIT = `${SLUG_APPLICANTS}${SLUG_EDIT}`;
export const PATH_APPLICANTS_EDIT_ID = `${SLUG_APPLICANTS}${SLUG_EDIT_ID}`;

const SLUG_EMPLOYEE = "/employee";
export const PATH_EMPLOYEE = `${SLUG_EMPLOYEE}`;
export const PATH_EMPLOYEE_ADD = `${SLUG_EMPLOYEE}${SLUG_ADD}`;
export const PATH_EMPLOYEE_EDIT = `${SLUG_EMPLOYEE}${SLUG_EDIT}`;
export const PATH_EMPLOYEE_EDIT_ID = `${SLUG_EMPLOYEE}${SLUG_EDIT_ID}`;

export const SLUG_TRAINING = "/training";
const SLUG_PARTICIPANTS = "/participants";

export const PATH_TRAINING_PARTICIPANTS = `${SLUG_TRAINING}${SLUG_PARTICIPANTS}`;
export const PATH_TRAINING_PARTICIPANTS_ADD = `${SLUG_TRAINING}${SLUG_PARTICIPANTS}${SLUG_ADD}`;
export const PATH_PARTICIPANTS_ADD = `${SLUG_PARTICIPANTS}${SLUG_ADD}`;
export const PATH_PARTICIPANTS_EDIT = `${SLUG_PARTICIPANTS}${SLUG_EDIT}`;
export const PATH_PARTICIPANTS_EDIT_ID = `${SLUG_PARTICIPANTS}${SLUG_EDIT_ID}`;

const SLUG_COURSES = "/courses";
const SLUG_COURSE_ID = ":courseId";
export const PATH_TRAINING_COURSES = `${SLUG_TRAINING}${SLUG_COURSES}`;
export const PATH_TRAINING_COURSES_ADD = `${SLUG_TRAINING}${SLUG_COURSES}${SLUG_ADD}`;
export const PATH_TRAINING_COURSES_EDIT = `${SLUG_TRAINING}${SLUG_COURSES}${SLUG_EDIT}`;
export const PATH_TRAINING_COURSES_EDIT_COURSE_ID = `${SLUG_TRAINING}${SLUG_COURSES}${SLUG_EDIT}${SLUG_COURSE_ID}`;
export const PATH_TRAINING_COURSES_EDIT_ID = `${SLUG_TRAINING}${SLUG_COURSES}${SLUG_EDIT_ID}`;

const SLUG_CERTIFICATIONS = "/certifications";
export const PATH_TRAINING_CERTIFICATIONS = `${SLUG_TRAINING}${SLUG_CERTIFICATIONS}`;
export const PATH_TRAINING_CERTIFICATIONS_ADD = `${SLUG_TRAINING}${SLUG_CERTIFICATIONS}${SLUG_ADD}`;
export const PATH_TRAINING_CERTIFICATIONS_EDIT = `${SLUG_TRAINING}${SLUG_CERTIFICATIONS}${SLUG_EDIT}`;
export const PATH_TRAINING_CERTIFICATIONS_EDIT_ID = `${SLUG_TRAINING}${SLUG_CERTIFICATIONS}${SLUG_EDIT_ID}`;

const SLUG_SUMMARY = "/summary";
export const PATH_TRAINING_SUMMARY = `${SLUG_TRAINING}${SLUG_SUMMARY}`;

const SLUG_MASS_UPDATE = "/mass-update";
export const PATH_TRAINING_MASS_UPDATE = `${SLUG_TRAINING}${SLUG_MASS_UPDATE}`;

const SLUG_CUSTOM_IDS = "/custom-ids";
export const PATH_CUSTOM_IDS = SLUG_CUSTOM_IDS;
export const PATH_CUSTOM_IDS_SUBPAGE = `${SLUG_CUSTOM_IDS}${SLUG_SUBPAGE}`;

const SLUG_SECURITY = "/security";
export const SLUG_SECURITY_SUBPAGE = `${SLUG_SECURITY}${SLUG_SUBPAGE}`;

export const PATH_SECURITY = SLUG_SECURITY;

export const editPathMap = [
  PATH_EMPLOYEE_EDIT,
  PATH_APPLICANTS_EDIT,
  PATH_PARTICIPANTS_EDIT,
  PATH_TRAINING_COURSES_EDIT,
  PATH_TRAINING_CERTIFICATIONS_EDIT,
];
